import React from 'react'
import classes from './PublishQues.module.css'
import { Col, Row } from 'react-bootstrap'
import BorderedSec from '../../../UI/BorderedSec'
import Card from '../../../UI/Card/Card'

const PublishQues = (props) => {
  return (
    <BorderedSec>
      <Card>
        <Row>
          <Col lg={12} md={12} sm={12}>
            <p className={classes["completed-ques__text1"]}>
              Q{props.qNo}. {props.qType}{" "}
            </p>
          </Col>
          {/* <Col lg={4} md={4} sm={5}>
                  <div className={classes["sec-editable"]}>
                    <SecBTN type="button" className={classes["cmplte-btn"]}>
                      Change Ques
                    </SecBTN>
                    <i className="bx bxs-edit"></i>
                  </div>
                </Col> */}
          <Col lg={3} md={6} sm={12} className="py-1">
            <Card className={classes["sec-card"]}>
              <b>Qid :</b> {props.qid}
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12} className="py-1">
            <Card className={classes["sec-card"]}>
              <b>topic :</b> {props.topic}
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12} className="py-1">
            <Card className={classes["sec-card"]}>
              <b>Sub-topic :</b> {props.subTopic}
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12} className="py-1">
            <Card className={classes["sec-card"]}>
              <b>Toughness :</b> {props.toughness}
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12} className="py-1">
            <Card className={classes["sec-card"]}>
              <b>Subject :</b> {props.sub_name}
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12} className="py-1">
            <Card className={classes["sec-card"]}>
              <b>Faculty :</b> {props.faculty}
            </Card>
          </Col>
          <Col lg={3} md={6} sm={12} className="py-1">
            <Card className={classes["sec-card"]}>
              <b>Type :</b> {props.type}
            </Card>
          </Col>
        </Row>
      </Card>
      <Row>
        <Col lg={6} md={12}>
          <Card className={classes["sec-card1"]}>
            <b>Question {props.qNo}: </b>
            <div dangerouslySetInnerHTML={{ __html: props.question }} />
            <ol
              style={{
                listStyleType: "upper-alpha",
                marginLeft: "30px",
              }}
            >
              {props.engOption !== null
                ? [...new Set(props.engOption.split("@@@"))].map((data, i) => {
                  return (
                    <li key={i}>
                      {" "}
                      <div dangerouslySetInnerHTML={{ __html: data }} />
                    </li>
                  );
                })
                : ""}
            </ol>
          </Card>
        </Col>
        <Col lg={6} md={12}>
          <Card className={classes["sec-card1"]}>
            <b>प्रश्न {props.qNo}: </b>
            <div dangerouslySetInnerHTML={{ __html: props.hindiQuestion }} />
            <ol
              style={{
                listStyleType: "upper-alpha",
                marginLeft: "30px",
              }}
            >
              {props.hindiOption !== null
                ? [...new Set(props.hindiOption.split("@@@"))].map(
                  (data, i) => {
                    return (
                      <li key={i}>
                        {" "}
                        <div dangerouslySetInnerHTML={{ __html: data }} />
                      </li>
                    );
                  }
                )
                : ""}
            </ol>
          </Card>
        </Col>
        <Col lg={12} md={12}>
          <p className={classes["crct-ans-opt"]}>
            Answer : <span>{props.correctAns}</span>
          </p>
        </Col>
        <Col lg={6} md={12}>
          <Card className={classes["sec-card1"]}>
            <b>Solution : </b>
            <div dangerouslySetInnerHTML={{ __html: props.answer }} />
          </Card>
        </Col>
        <Col lg={6} md={12}>
          <Card className={classes["sec-card1"]}>
            <b>उत्तर : </b>
            <div dangerouslySetInnerHTML={{ __html: props.hindiAnswer }} />
          </Card>
        </Col>
      </Row>
      {/* <Card className={classes["sec-card1"]}>
              <b>Question : </b> 
            </Card>
            
            <Card className={classes["sec-card1"]}>
              <b>Solution : </b>
            </Card> */}
    </BorderedSec>
  );
}

export default PublishQues
